import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_BLOG_POSTS_TABLE } from "../../../constants/FirebaseConstants";

export function useBlogPosts() {
  const { data } = useSWRSubscription("blogPosts", (key, { next }) => {
    const q = query(
      collection(db, FIRESTORE_BLOG_POSTS_TABLE),
      orderBy("createdAt", "desc"),
    );
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
